import { atom } from "recoil";

const employeeInfoAtom = atom({

    key:"employeeInfoState",
    default: {}

});

export default employeeInfoAtom;